import { Component, EventEmitter, Input, Output } from "@angular/core";

@Component({
  selector: "page-card-item-action",
  template: "",
  standalone: false
})
export class PageCardItemActionComponent {
  @Input() icon!: string;
  @Input() title!: string;
  @Output() onClick: EventEmitter<void> = new EventEmitter();
}
